var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-311 -34)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(311 34)",
    fill: "#f5333f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.826.123,12.345,1.851,10.246.123a.613.613,0,0,0-.741,0l-2.1,1.728L5.308.123a.613.613,0,0,0-.741,0l-2.1,1.728L.988.123A.617.617,0,0,0,0,.616V19.133a.617.617,0,0,0,.988.494L2.469,17.9l2.1,1.728a.613.613,0,0,0,.741,0l2.1-1.728,2.1,1.728a.613.613,0,0,0,.741,0l2.1-1.728,1.481,1.728a.617.617,0,0,0,.988-.494V.616a.617.617,0,0,0-.988-.494ZM12.345,13.887a.31.31,0,0,1-.309.309H2.778a.31.31,0,0,1-.309-.309V13.27a.31.31,0,0,1,.309-.309h9.258a.31.31,0,0,1,.309.309Zm0-3.7a.31.31,0,0,1-.309.309H2.778a.31.31,0,0,1-.309-.309V9.566a.31.31,0,0,1,.309-.309h9.258a.31.31,0,0,1,.309.309Zm0-3.7a.31.31,0,0,1-.309.309H2.778a.31.31,0,0,1-.309-.309V5.863a.31.31,0,0,1,.309-.309h9.258a.31.31,0,0,1,.309.309Z",
    transform: "translate(324.433 45.342)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBill);
export default __webpack_public_path__ + "static/media/my-bill.8175421b4c39fef4de0bc09911a96c58.svg";
export { ForwardRef as ReactComponent };